(function ($) {
  const setBackgroundImage = () =>{
    let windowWidth = $(window).width();
    $('.sectionDataSource').each(function () {
      let sectionId = $(this).attr("id");
      let dataRegularSource = $(this).attr("data-regular-source");
      let dataDesktopSource = $(this).attr("data-desktop-source");
      let dataMobileSource = $(this).attr("data-mobile-source");

      let backgroundImageSource = dataRegularSource ? dataRegularSource : "";

      if (windowWidth < 1280 && windowWidth > 576 && dataDesktopSource) {
        backgroundImageSource = dataDesktopSource;
      } else if (windowWidth < 576 && dataMobileSource) {
        backgroundImageSource = dataMobileSource;
      } else if (windowWidth < 576 && dataDesktopSource) {
        backgroundImageSource = dataDesktopSource;
      }
           
      if (backgroundImageSource) {
        $(`.bs-section-${sectionId}`).css(
          "background-image",
          `url(${backgroundImageSource})`
        );
      }
    });
  }

  $(window).on("load", setBackgroundImage());
  $(window).resize(function () {
    setBackgroundImage();
  });
})(jQuery);